<template>
  <div>
    <CRow class="mb-3 search-panel">
      <CCol>
        <div class="form-group">
          <div style="margin-top: 10px">
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tải lại'"
              class="btn-action-primary"
              @click="loadDataMainTable(true)">
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
            <CButton
              style="float: right;margin-left: 5px;"
              color="primary"
              v-c-tooltip.hover="'Tạo Key'"
              class="btn-action-primary"
              @click="generateKey()">
              <i class="fa fa-plus"></i>&nbsp;Tạo KEY
            </CButton>
          </div>
        </div>
      </CCol>
    </CRow>
    <CCard class="content-fade-in mt-3p5">
      <CCardBody>
        <BaseTable
          :options="mainTable.options"
          :slots="mainTable.slots"
          :dataSource="mainTable.dataSource"
          ref="mainTable"
        >
          <template #index="{index}">
            <td>{{ $refs.mainTable.getTotalElementByPage + index }}</td>
          </template>
          <template #createDate="{item}">
            <td>
              {{ $helper.formatDateDDMMYYYYHHMM(item.createDate) }}
            </td>
          </template>
          <template #privateKey="{item}">
            <td>
              <span class="description">{{ item.privateKey }}</span>
              <i class="fa fa-copy btnCopy" v-c-tooltip.hover="'Copy'" @click="copyKey(item.privateKey)"></i>
            </td>
          </template>
          <template #publicKey="{item}">
            <td>
              <span class="description">{{ item.publicKey }}</span>
              <i class="fa fa-copy btnCopy" v-c-tooltip.hover="'Copy'" @click="copyKey(item.publicKey)"></i>
            </td>
          </template>
        </BaseTable>
      </CCardBody>
    </CCard>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import ModalConfirm from "../base/BaseModalConfirm";
import BaseInput from "../base/BaseInput";
import BaseSelect from "../base/BaseSelect2"
import BaseFormLoading from "@/views/base/BaseFormLoading";

export default {
  name: "KeyAuthenticationList",
  components: {
    BaseFormLoading,
    BaseTable,
    ModalConfirm,
    BaseInput,
    BaseSelect
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    let that = this;
    return {
      loading: {value: false},
      mainTable: {
        options: {
          fields: [
            {key: "index", label: "STT", sorter: false, filter: false},
            {key: "createDate", label: "Ngày tạo"},
            {key: "createUserName", label: "Người tạo"},
            {key: "privateKey", label: "Private"},
            {key: "publicKey", label: "Public"},
          ],
          slots: ["index", "createDate", "privateKey", "publicKey"],
          pageSize: 15,
          sorter: true,
          columnFilter: false,
          clickableRows: true,
        },
        dataSource: {
          url: "/key-authen/getPages",
          dataSubmit: function () {
            return {}
          },
          response: function (dataResponse) {
            return dataResponse.data;
          }
        }
      },
    };
  },
  methods: {
    loadDataMainTable: function (isUpdateFilter) {
      this.$refs.mainTable.loadData(true, isUpdateFilter);
    },
    generateKey() {
      let that = this
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/key-authen/create",
        dataSubmit() {
          return {}
        },
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.showSuccessMsg({message: 'Tạo KEY mới thành công'})
            that.loadDataMainTable();
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
    copyKey(value) {
      navigator.clipboard.writeText(value);
      this.showSuccessMsg({message: 'Copy thành công'})
    }
  },
  created: function () {
  },
  mounted() {
  },
  watch: {},
  computed: {}
};
</script>
<style scoped>
.td-roles {
  max-width: 250px;
}

.btnCopy {
  font-size: 20px;
  cursor: pointer;
}
</style>
